import script from "./customer-summary.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-summary.vue?vue&type=script&setup=true&lang=js"

import "./customer-summary.vue?vue&type=style&index=0&id=3c48cfe2&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c48cfe2"]])

export default __exports__